// Helpers partagés pour l'import Excel d'engins (affaire nouvelle, incorporation,
// renouvellement). Centralise l'appariement des garanties (libellés Excel → vraies
// garanties en base) et la résolution des sous-garanties (primes) pour l'aperçu.

// Normalise un libellé de garantie pour l'appariement : sans accents, espaces réduits, casse.
export const normGarantiLabel = (s) => String(s || "")
    .normalize("NFKD").replace(/[̀-ͯ]/g, "")
    .replace(/\s+/g, " ").trim().toLowerCase();

/**
 * Apparie des libellés de garanties (issus du fichier Excel : « VOL », « DEFENSE RECOURS »…)
 * aux garanties RÉELLES d'un catalogue et renvoie leurs identifiants.
 * - `catalog` : liste de garanties disponibles ;
 * - `getName(item)` / `getId(item)` : accès au libellé et à l'identifiant d'une garantie.
 * Les libellés non reconnus sont ignorés (pas de sélection fantôme).
 */
export const matchGarantieNamesToIds = (names, catalog, getName, getId) => {
    if (!Array.isArray(names)) return [];
    const list = Array.isArray(catalog) ? catalog : [];
    return names
        .map((n) => {
            const target = normGarantiLabel(n);
            const found = list.find((g) => normGarantiLabel(getName(g)) === target);
            return found ? getId(found) : null;
        })
        .filter((v) => v !== null && v !== undefined);
};

/**
 * Résout les SOUS-GARANTIES (avec primes) d'un jeu de garanties (codeId) via l'endpoint
 * /api/sous-garantie/garanties — comme la sélection manuelle. Nécessaire pour que l'aperçu
 * prenne en compte les garanties importées (le backend lit engin.sousGaranties).
 * `catalog` : liste {codeId, …} pour reconstituer les objets garantie envoyés au backend.
 * `cache` : objet réutilisable (un seul appel par jeu identique — flotte = même jeu partout).
 */
export const resolveSousGarantiesByCodeIds = async (codeIds, catalog, axiosInstance, cache = {}) => {
    const ids = Array.isArray(codeIds) ? codeIds : [];
    const key = [...ids].sort().join("|");
    if (!key) return [];
    if (cache[key]) return cache[key];
    const gtys = ids
        .map((id) => (catalog || []).find((g) => g && g.codeId === id))
        .filter(Boolean);
    try {
        const res = await axiosInstance.post(`/api/sous-garantie/garanties`, JSON.stringify(gtys));
        cache[key] = res.data || [];
    } catch (e) {
        cache[key] = [];
    }
    return cache[key];
};
